"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var NotificationsModule = /** @class */ (function () {
    function NotificationsModule() {
    }
    return NotificationsModule;
}());
exports.NotificationsModule = NotificationsModule;
